
const digest = '4326870ed4195a676d32dc6111a8137625e7a2b757b2051ea00c8d5d57671f90';
const classes = {"wrapper":"_wrapper_fg7dp_1","title":"_title_fg7dp_6","workplacesWrapper":"_workplacesWrapper_fg7dp_10","workplace":"_workplace_fg7dp_10","workplaceInForm":"_workplaceInForm_fg7dp_33","selectsWrapper":"_selectsWrapper_fg7dp_43","item":"_item_fg7dp_49","multiplierButton":"_multiplierButton_fg7dp_52","button":"_button_fg7dp_56","rootWorkplace":"_rootWorkplace_fg7dp_60","code":"_code_fg7dp_76"};
const css = `._wrapper_fg7dp_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_fg7dp_1 ._title_fg7dp_6 {
  font-size: 16px;
  font-weight: 600;
}
._wrapper_fg7dp_1 ._workplacesWrapper_fg7dp_10 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_fg7dp_1 ._workplacesWrapper_fg7dp_10 ._workplace_fg7dp_10 {
  background: #e7f5fb;
  border-radius: 15px;
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 14px;
  gap: 12px;
  border: 1px solid #dee9ff;
  align-items: center;
  justify-content: space-between;
  color: #2f61b2;
}
._wrapper_fg7dp_1 ._workplacesWrapper_fg7dp_10 ._workplace_fg7dp_10 span {
  font-weight: 400;
  color: #000000;
}
._wrapper_fg7dp_1 ._workplacesWrapper_fg7dp_10 ._workplaceInForm_fg7dp_33 {
  background: #f6f6f8;
  border-radius: 15px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #ecedf3;
  margin-bottom: 10px;
}
._wrapper_fg7dp_1 ._workplacesWrapper_fg7dp_10 ._workplaceInForm_fg7dp_33 ._selectsWrapper_fg7dp_43 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
._wrapper_fg7dp_1 ._workplacesWrapper_fg7dp_10 ._workplaceInForm_fg7dp_33 ._selectsWrapper_fg7dp_43 ._item_fg7dp_49 {
  flex: 1;
}
._wrapper_fg7dp_1 ._workplacesWrapper_fg7dp_10 ._workplaceInForm_fg7dp_33 ._selectsWrapper_fg7dp_43 ._multiplierButton_fg7dp_52 {
  padding-top: 30px;
  display: inline-block;
}
._wrapper_fg7dp_1 ._button_fg7dp_56 {
  width: fit-content;
  margin-top: 15px;
}
._wrapper_fg7dp_1 ._rootWorkplace_fg7dp_60 {
  background: #f6f6f8;
  border-radius: 15px;
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 14px;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  border: 2px solid #1765d8;
}
._wrapper_fg7dp_1 hr {
  width: 100%;
}
._wrapper_fg7dp_1 ._code_fg7dp_76 {
  font-size: 14px;
  padding: 3px 0;
}
._wrapper_fg7dp_1 ._code_fg7dp_76 span {
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  